import React from 'react';
import { TextInput, Tooltip } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationCrosshairs, faTrash } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { PUBLIC_ATTENDANCE_RADIUS_METERS } from 'shared-models/browser';
import { Button } from '../../../components/Button';
import type { TenantView } from '../../../services/tenants/tenants.service';
import type { TenantAttendanceLocationController } from '../useTenantAttendanceLocation';
import { noSelectionTextInputProps } from '../../PosShellPage/components/receipt/receipt-input.utils';
import classes from '../tenants-page.module.scss';

export function TenantAttendanceLocationBlock({ tenant, controller, isUpdating }: {
  tenant: TenantView; controller: TenantAttendanceLocationController; isUpdating: boolean;
}) {
  const draft = controller.getDraft(tenant);
  const locating = controller.locatingTenantId === tenant.id;
  return <div className={classes.tenbisSlot} data-testid={`tenants-attendance-location-${tenant.id}`}>
    <span className={classes.photoLabel}>מיקום כניסה למשמרת דרך QR ציבורי · {PUBLIC_ATTENDANCE_RADIUS_METERS} מטר</span>
    <div className={classes.settingsGrid}>
      <TextInput label="קו רוחב" type="number" step="any" min={-90} max={90} inputMode="decimal" dir="ltr"
        {...noSelectionTextInputProps} value={draft.latitude} disabled={isUpdating || locating}
        onChange={(event) => controller.setDraft(tenant.id, { ...draft, latitude: event.currentTarget.value })}
        data-testid={`tenants-attendance-latitude-${tenant.id}`} />
      <TextInput label="קו אורך" type="number" step="any" min={-180} max={180} inputMode="decimal" dir="ltr"
        {...noSelectionTextInputProps} value={draft.longitude} disabled={isUpdating || locating}
        onChange={(event) => controller.setDraft(tenant.id, { ...draft, longitude: event.currentTarget.value })}
        data-testid={`tenants-attendance-longitude-${tenant.id}`} />
    </div>
    <div className={classes.tenbisActions}>
      <Button variant="save" size="sm" loading={locating} loadingLabel="מאתר..." disabled={isUpdating || controller.locatingTenantId !== null}
        onClick={() => { void controller.useCurrentLocation(tenant); }} dataTestId={`tenants-attendance-use-location-${tenant.id}`}>
        <FontAwesomeIcon icon={faLocationCrosshairs as IconProp} /> השתמש במיקום שלי
      </Button>
      <Tooltip label="נקה מיקום"><span><Button variant="icon" ariaLabel="נקה מיקום" disabled={isUpdating || locating || (!draft.latitude && !draft.longitude)}
        onClick={() => controller.setDraft(tenant.id, { latitude: '', longitude: '' })} dataTestId={`tenants-attendance-clear-location-${tenant.id}`}>
        <FontAwesomeIcon icon={faTrash as IconProp} />
      </Button></span></Tooltip>
    </div>
  </div>;
}